import React, { useState } from 'react';
import PropTypes from 'prop-types';

import Modal, {
  ModalHeroImage,
  ModalTitle,
  ModalBody,
  ModalActions
} from '@strava/ui/Modal';
import Button from '@strava/ui/Button';

import { trackV2 } from 'utils/analytics';
import utils from 'utils/generalUtils';
import I18n from 'utils/I18n';

import polylineImage from './assets/sub_preview_conversion_modal.png';
import styles from './PostSubscriptionPreviewModal.scss';

export const i18nPrefix = 'components.subscription_preview.conversion_modal';

export const PostSubscriptionPreviewModal = ({ path }) => {
  const [isOpen, setIsOpen] = useState(true);
  const closeModal = () => setIsOpen(false);

  const handlePrimarySubmit = (e) => {
    e.preventDefault();
    trackV2({
      category: 'subscriptions',
      page: 'sub_preview_end_landing',
      action: 'click',
      element: `subscribe_now${utils.isMobile() ? '_mobile_web' : ''}`
    });
    window.location.href = path;
    closeModal();
  };

  const dismissModal = () => {
    trackV2({
      category: 'subscriptions',
      page: 'sub_preview_end_landing',
      action: 'click',
      element: 'no_thanks'
    });
    closeModal();
  };

  return (
    <Modal
      isOpen={isOpen}
      onDismiss={dismissModal}
      hasClose={false}
      className={styles.modal}
      aria-labelledby="post-preview-modal-title"
      data-testid="modal"
    >
      <ModalHeroImage src={polylineImage} alt={`${i18nPrefix}.title`} />
      <ModalTitle className={styles.title} id="post-preview-modal-title">
        {I18n.t(`${i18nPrefix}.title`)}
      </ModalTitle>
      <ModalBody>
        <div className={styles.description}>
          {I18n.t(`${i18nPrefix}.subtitle`)}
        </div>
      </ModalBody>
      <ModalActions style={{ justifyContent: 'space-between' }}>
        <Button
          className={styles.button}
          variant="primary"
          type="button"
          data-testid="subscribe-btn"
          onClick={handlePrimarySubmit}
        >
          {I18n.t(`${i18nPrefix}.cta_subscribe`)}
        </Button>
        <Button
          className={styles.button}
          variant="text"
          type="button"
          data-testid="dismiss-btn"
          onClick={dismissModal}
        >
          {I18n.t(`${i18nPrefix}.cta_dismiss`)}
        </Button>
      </ModalActions>
    </Modal>
  );
};

PostSubscriptionPreviewModal.propTypes = {
  path: PropTypes.string.isRequired
};

export default PostSubscriptionPreviewModal;
